import { BaseListViewStore } from 'core/stores';
import { action, makeObservable, _getAdministration } from 'mobx';
import { RemoveFiltersModalUtility, notificationError } from 'core/utils';
import { BaasicTableSettingsViewStore } from 'common/stores';
import { ChargesCellData, ChargesDifferenceCellData, HyperlinkCellData } from 'core/stores/CellDataStore';
import ShipmentCostStore from './ShipmentCostStore';
import moment from 'moment';
import _ from 'lodash';

class ShipmentCostChargeListViewStore extends BaseListViewStore {
	noDataItem = true;
	showOnlyTotal = true;
	data = [];

	constructor(rootStore) {
		super(rootStore, {
			listStore: new ShipmentCostStore(rootStore),
			queryParams: {
				findFunction: 'findShipmentCostCharge',
				ignore: true,
			},
		});
		this.defineTableData();
		makeObservable(this);
		this.parentViewStore = rootStore.shipmentCostViewStore;
		this.queryUtility.initialize(this.findShipmentCostCharge, false);
		this.removeFiltersModal = new RemoveFiltersModalUtility({ viewStore: this });
	}

	@action.bound
	defineTableData = () => {
		this.tableData = {
			columns: [
				{
					key: 'name',
					title: 'SHIPMENTCOST.CHARGEID',
					dataCell: HyperlinkCellData,
					onClick: dataItem => this.setChargeIdFilter(dataItem),
					selected: true,
					sortable: false,
					width: 120,
					filter: null,
				},
				{
					key: 'totalQuoted',
					title: 'SHIPMENTCOST.QUOTEDRATE',
					dataCell: ChargesCellData,
					formatter: this.rootStore.usdFormatter,
					selected: true,
					sortable: false,
					width: 120,
					filter: null,
				},
				{
					key: 'totalBilled',
					title: 'SHIPMENTCOST.BILLEDRATE',
					dataCell: ChargesCellData,
					formatter: this.rootStore.usdFormatter,
					selected: true,
					sortable: false,
					width: 120,
					filter: null,
				},
				{
					key: 'totalDifference',
					title: 'SHIPMENTCOST.DIFFERENCE',
					dataCell: ChargesDifferenceCellData,
					formatter: this.rootStore.usdFormatter,
					selected: true,
					sortable: false,
					width: 120,
					filter: null,
				},
			],
			actions: {},
			sortObject: [],
		};
	};

	@action.bound
	findShipmentCostCharge = async () => {
		this.suspend();
		this.data = [];
		try {
			const { dateRangeStart, dateRangeEnd, ...otherValues } = this.parentViewStore.form.values();
			if (dateRangeStart && otherValues.carrierId) {
				if (this.baasicTableSettingsViewStore == undefined) {
					this.baasicTableSettingsViewStore = new BaasicTableSettingsViewStore(this.rootStore);
				}
				this.queryUtility.setFilterParams(
					this,
					{
						dateStart: dateRangeStart == '' ? null : moment(dateRangeStart).format(),
						dateEnd:
							dateRangeEnd == ''
								? null
								: moment(dateRangeEnd)
										.set({
											hour: 23,
											minute: 59,
											second: 59,
										})
										.format(), // This will format date with timezone and backend will automatically convert to UTC when parsing
						shipmentInfoChargeTypeIds:
							this.parentViewStore.chargeTypeFilter != null && this.parentViewStore.chargeTypeFilter.id != null
								? [this.parentViewStore.chargeTypeFilter.id]
								: null,
						shipmentInfoType: this.parentViewStore.shipmentTypeFilter.selectedValue,
						...otherValues,
					},
					this.tableFilter
				);
				await this.listStore.findCharge(this.queryUtility.filter);
				if (this.listStore.response.item.length === 0 && this.listStore.response.page !== 1) {
					await this.queryUtility.changePage(1, false);
				}
				this.queryUtility.handleResponse(this.listStore.response);
				this.data = this.listStore.response.item;
				this.parentViewStore.shipmentCostTotals = this.listStore.response.shipmentCostTotals;
			}
		} catch (err) {
			notificationError({ store: this.rootStore.notificationStore, err });
		}

		this.resume();
	};

	@action.bound
	setChargeIdFilter = async chargeType => {
		this.parentViewStore.chargeTypeFilter = chargeType;
		await this.parentViewStore.reloadChildViewStores();
	};
}

export default ShipmentCostChargeListViewStore;



// WEBPACK FOOTER //
// ./src/modules/shipment-cost/stores/ShipmentCostChargeListViewStore.js